export const GET_NULL_WSPOSITIONS = 'GET_NULL_WSPOSITIONS';
export const GET_NULL_WSPOSITIONS_SUCCESS = 'GET_NULL_WSPOSITIONS_SUCCESS';
export const GET_NULL_WSPOSITIONS_ERROR = 'GET_NULL_WSPOSITIONS_ERROR';
